import { render, staticRenderFns } from "./CheckboxServer.vue?vue&type=template&id=8c32c3c4&scoped=true&"
import script from "./CheckboxServer.vue?vue&type=script&lang=js&"
export * from "./CheckboxServer.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxServer.vue?vue&type=style&index=0&id=8c32c3c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c32c3c4",
  null
  
)

export default component.exports